<template>
  <aside v-if="isAuthorized && userActiveViewState !== 1" class="menu" style="width: 230px">
      <ul class="menu-list" :class="{ 'fob-menu-is-disabled': !userHasOrga }">

        <li class="orga-select" v-on:keyup.escape="closeOrgaSelect">
          <b-dropdown ref="orgaselect" v-if="userIsAuthorized && userOrgas.length > 0" v-model="activeOrga">
            <button class="button is-basalt" slot="trigger">
                <div>
                  <div>
                    {{ userOrgas[activeOrga].name }}
                  </div>
                  <!--
                  <em>
                    {{ userOrgas[activeOrga].parentName }}
                  </em>
                  -->
                </div>
                <b-icon type="is-small" icon="angle-right"></b-icon>
            </button>

            <b-dropdown-item
              v-for="(orga, i) in userOrgas"
              :value="i"
              :key="orga.kst"
            >
              <div
                class="media"
                tabindex="0"
                v-on:keyup.enter="() => selectOrga(i)"
              >
                <div class="media-content">
                  <h3>{{ orga.name }}</h3>
                  <small>{{ orga.parentName }}</small>
                </div>
              </div>
            </b-dropdown-item>
          </b-dropdown>
        </li>

        <li v-for="(item, i) in menu" :key="i" :class="{ 'fob-menu-item-is-disabled': item.disabled }">
          <router-link :class="item.classes || []" :exact="item.exact" :to="item.link" >
            <span v-if="item.icon" class="icon">
              <i :class="item.icon"></i>
            </span> <translate>{{ item.name }}</translate>{{ item.marked ? '*' : '' }}
          </router-link>
        </li>
      </ul>
  </aside>
</template>

<script>
import { mapGetters } from 'vuex'
import DateTimeHelper from '@/components/mixins/DateTimeHelper'
import ExternalLinkProvider from '@/components/mixins/ExternalLinkProvider'

export default {
  name: 'fob-menu',
  mixins: [DateTimeHelper, ExternalLinkProvider],
  methods: {
    closeOrgaSelect () {
      if (this.$refs.orgaselect.isActive) {
        this.$refs.orgaselect.toggle()
      }
    },
    selectOrga (i) {
      this.$refs.orgaselect.toggle()
      this.activeOrga = i
    }
  },
  computed: {
    ...mapGetters({
      menu: 'getMainMenu',
      version: 'getVersion',
      isAuthorized: 'user/isAuthorized',
      userActiveViewState: 'user/activeViewState',
      username: 'user/name',
      userHasOrga: 'user/hasOrga',
      userResearcher: 'user/researcher',
      userOrgas: 'user/orgas',
      userFisPersid: 'user/fisPersid',
      userIsAuthorized: 'user/isAuthorized'
    }),
    activeOrga: {
      get () {
        return this.$store.getters['user/activeOrga']
      },
      set (value) {
        this.$store.dispatch('user/changeOrga', value)
        this.$router.push({ name: 'start' })
      }
    },
    userActiveViewState: {
      get () {
        return this.$store.getters['user/activeViewState']
      },
      set (id) {
        this.$store.dispatch('user/activeViewState', id)
      }
    },
    onLoginPage () {
      return this.$route.name === 'login'
    }
  }
}
</script>

<style lang="scss">
/* bulma.io class 'is-italic' does not seem to work? */
.fob-text-italic {
  font-style: italic;
}

.menu-list {
  // margin-top: 20px;
}

.menu-list a:focus-visible {
  outline: 2px solid #262A31;
}

.fob-menu-is-disabled, .fob-menu-item-is-disabled {
  cursor: not-allowed;
  opacity: 0.5;
}
.fob-menu-is-disabled li > a {
  width: 100%;
  color: currentColor;
  display: inline-block;  /* For IE11/ MS Edge bug */
  pointer-events: none;
  text-decoration: none;
}
.fob-menu-item-is-disabled > a {
  width: 100%;
  color: currentColor;
  display: inline-block;  /* For IE11/ MS Edge bug */
  pointer-events: none;
  text-decoration: none;
}

.orga-select {
  margin-bottom: 40px;
}

.orga-select .dropdown-menu {
  margin-left: 236px;
  margin-top: -44px;
}

.orga-select .dropdown-content {
  padding: 0;
  border-radius: 0;
}

.orga-select button {
  width: 230px;
  border-radius: 0;
  min-height: 40px;
  height: unset;
  max-height: unset;
}

.orga-select a:focus-within:not(.is-active) {
  background-color: #f0f0f0;
}

.orga-select a div {
  outline: none;
}

.orga-select button div:first-child {
  width: 180px;
  overflow-x: hidden !important;
  text-overflow: ellipsis;
  text-align: left;
// for multi-line button, not used so far
//   white-space: normal;
//   word-wrap: break-word !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Menu.vue